export default "__VITE_ASSET__058743d4__"